import Category from "../../layouts/Category/Category"


const CategoryPage = () => {
    return(
        <Category />
    )
}

export default CategoryPage;